

    function Slider(startIndex, slideCount, autoStepTimeout) {
        this.slideIndex = startIndex;
        this.slideCount = slideCount;

        if (autoStepTimeout) {
            this.SLIDE_AUTO = true;
            this.SLIDE_AUTO_TIMEOUT = autoStepTimeout;
            this.windowFocus = true;
            var self = this;
            window.onfocus = function () {
                self.windowFocus = true;
            }
            window.onblur = function () {
                self.windowFocus = false;
            }
        } else {
            this.SLIDE_AUTO = false;
            this.SLIDE_AUTO_TIMEOUT = 0;
            this.windowFocus = null;
        }
    }
    Slider.tmr = null;
    Slider.prototype.start = function () {
        this.stepTo(this.slideIndex, true);
        if (this.SLIDE_AUTO) {
            this.autoStep();
        }
    }
    Slider.prototype.stepTo = function (index, triggerClick) {
        index = parseInt(index, 10);
        var el = document.querySelector('#st-' + index);
        if (el) {
            this.slideIndex = index;

            // Remove active class from labels
            Array.prototype.slice.call(document.querySelectorAll('.ap-slider footer label')).forEach(function (label) {
                label.className = '';
            });

            // Set active class on current label
            var currentLabel = document.querySelector('.ap-slider footer label[for="st-' + index + '"]');
            if (currentLabel) {
                currentLabel.className = 'active';
            }

            if (triggerClick) {
                // remove checked attribute from all radio input
                Array.prototype.slice.call(document.querySelectorAll('.ap-slider input[type="radio"]')).forEach(function (radio) {
                    radio.removeAttribute('checked');
                });
                // check selected radio input
                el.click.apply(el);
            }
        }
        if (!this.SLIDE_AUTO) {
            this.SLIDE_AUTO = true;
            this.autoStep();
        }
    }
    Slider.prototype.stepDelta = function (delta) {
        var newIndex = this.slideIndex + delta;
        if (newIndex < 0) { newIndex = this.slideCount -1; }
        else if (newIndex >= this.slideCount) { newIndex = 0; }
        this.stepTo(newIndex, true);
    }
    Slider.prototype.autoStep = function () {
        var self = this;
        if(self.tmr!=undefined)
            clearTimeout(self.tmr);
        self.tmr=setTimeout(function () {
            if (self.SLIDE_AUTO) {
                if (self.windowFocus) {
                    self.stepDelta(1);
                }
                self.autoStep();
            }
        }, self.SLIDE_AUTO_TIMEOUT);
    }

